module.exports = __webpack_public_path__ + "img/card1.07728122.png";